import { useState } from 'react';

/**
 * 極簡 toast — 不裝套件。
 *
 * 用法：
 *   const [toast, showToast] = useToast();
 *   showToast('Sent! Check your inbox.');
 *   <Toast {...toast} />
 */

export interface ToastState {
  message: string;
  visible: boolean;
}

export function useToast() {
  const [state, setState] = useState<ToastState>({ message: '', visible: false });

  function show(message: string, durationMs = 2400) {
    setState({ message, visible: true });
    window.setTimeout(() => setState((s) => ({ ...s, visible: false })), durationMs);
  }

  return [state, show] as const;
}

export function Toast({ state }: { state: ToastState }) {
  // 為了無內容時也保留 portal slot，用 visibility / opacity 動畫
  return (
    <div
      role="status"
      aria-live="polite"
      className={[
        'fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 transform rounded-full border border-border bg-fg px-5 py-2.5 text-sm text-bg shadow-lg transition-all duration-200',
        state.visible ? 'opacity-100 translate-y-0' : 'pointer-events-none opacity-0 translate-y-2',
      ].join(' ')}
    >
      {state.message}
    </div>
  );
}
